// extracted by mini-css-extract-plugin
module.exports = {"price":"Price_price__15wXc","totalPrice":"Price_totalPrice__1ej0L"};